import panel_time_pick_vue_vue_type_script_setup_true_lang_default from "./panel-time-pick.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/time-picker/src/time-picker-com/panel-time-pick.vue
var panel_time_pick_default = panel_time_pick_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { panel_time_pick_default as default };
//# sourceMappingURL=panel-time-pick.mjs.map